(function ($) {

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  function renderUpsells(cart) {
    const container = $('#cart-upsell-container');
    if (!container.length) return;

    if (!cart.items || cart.items.length === 0) {
      container.empty();
      container.hide();
      return;
    }

    container.show();
    container.empty();

    const cartProductIds = cart.items.map(item => item.product_id);
    const upsells = (window.preOrderUpsells || []).filter(product => {
      return !cartProductIds.includes(product.id);
    });

    if (!upsells || upsells.length === 0) return;

    let html = `
      <h3 class="m-cart-drawer__title m-cart-drawer__title m:text-xl m:font-medium">You may also like</h3>
      <div class="owl-carousel you-may-also-like-carousel">
    `;

    upsells.forEach(product => {
      html += `
        <div class="item text-center p-2">
          <a href="${product.url}">
            <div class="m-cart-drawer-item__image m-cart-item__image">
              <img src="${product.image}" alt="${product.title}" class="w-full h-auto object-cover mb-1 rounded">
            </div>
            <div>
              <p class="title">${product.title}</p>
              <p class="price">$${formatMoney(product.price)}</p>
            </div>
          </a>
        </div>`;
    });

    html += `</div>`;
    container.html(html);

    const $carousel = $('.you-may-also-like-carousel');

    if ($carousel.hasClass('owl-loaded')) {
      $carousel.trigger('destroy.owl.carousel').removeClass('owl-loaded');
    }

    $carousel.owlCarousel({
      items: 1,
      loop: true,
      margin: 10,
      nav: true,
      dots: false,
      navText: [
        '<span class="prev">&#10094;</span>',
        '<span class="next">&#10095;</span>'
      ],
    });
  }

  function fetchAndRenderUpsells() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => renderUpsells(cart));
  }

  $(document).ready(() => {

    const observer = new MutationObserver((mutations, obs) => {
      const container = document.querySelector('#cart-upsell-container');
      if (container) {
        fetchAndRenderUpsells();
        obs.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('Minimog:cart:sections:updated', (e) => {
      const cart = e.detail?.cart || null;
      if (cart) renderUpsells(cart);
      else fetchAndRenderUpsells();
    });

    const drawer = document.querySelector('#MinimogCartDrawer [data-minimog-cart-items]');
    if (drawer) {
      const drawerObserver = new MutationObserver(() => fetchAndRenderUpsells());
      drawerObserver.observe(drawer, { childList: true, subtree: true });
    }

  });

})(jQuery);
